import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=0c31479f&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=0c31479f&prod&scoped=true&lang=css"
import style1 from "./productDetail.vue?vue&type=style&index=1&id=0c31479f&prod&scoped=true&lang=css"
import style2 from "./productDetail.vue?vue&type=style&index=2&id=0c31479f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31479f",
  null
  
)

export default component.exports